import React from 'react'
import { Card, CardBody, Badge, Button } from '@/components/ui-compat'
import { useTranslation } from 'react-i18next'
import { useQuery } from '@apollo/react-hooks'
import { Query } from '../../api'
import Loader from '../../components/Loader'
import { capitalize } from 'lodash'

export const Subscription = () => {
  const { t } = useTranslation()
  const { data, loading } = useQuery(Query.ME)

  if (loading || !data?.me) return <Loader />

  const plan = data.me.organization?.subscription || 'FREE'

  return (
    <Card className="mt-3">
      <CardBody className="text-center py-5">
        <h3 className="mb-3">{t('subscription_title', 'Your Subscription')}</h3>
        <div className="mb-4">
          <Badge color={plan === 'PREMIUM' ? 'success' : 'primary'} className="px-3 py-2" style={{ fontSize: '1.2rem' }}>
            {capitalize(plan.toLowerCase())}
          </Badge>
        </div>
        {plan === 'FREE' || plan === 'STARTER' ? (
          <div>
            <p className="text-muted-foreground mb-3">
              {t('subscription_free_info', 'You are on the Free plan. Contact us to upgrade to Premium for unlimited access.')}
            </p>
            <Button
              color="primary"
              onClick={() => window.open('mailto:info@urkla.com')}
            >
              {t('Contact_us', 'Contact us')}
            </Button>
          </div>
        ) : (
          <p className="text-muted-foreground">
            {t('subscription_premium_info', 'You have full access to all features.')}
          </p>
        )}
      </CardBody>
    </Card>
  )
}

export default Subscription
